// extracted by mini-css-extract-plugin
export default {"logo":"Topbar_logo__ewets","logout":"Topbar_logout__H4uGj"};